const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'number',
      product: 'interior3d_standard',
    },
  },
  droneShooting: {
    operation: 'update',
    update: {
      target: 'all',
      type: 'mapTo',
      mapTo: [ 'droneShooting' ],
    },
  },
};


const dependencies = {
  hard: [],
  soft: [
    {
      if: {
        key: 'droneShooting',
        value: true,
      },
      then: {
        operation: 'createOrUpdate',
        createOrUpdate: {
          product: 'droneShooting_standard',
          service: 'droneShooting',
          with: { interior3d: true },
        },
      },
    }
  ],
};


export default { specs, dependencies };
